import styled from 'styled-components';
import { color, backgroundColor } from '../../../../ui-kit/helpers';
import { Row } from '../../../../ui-kit';

// This component allows certain flexibility when creating it.
// passing the fluid prop, the width of the container has no minimum width
// passing the header prop gives the component a dark blue background
// passing the subheader prop gives the component a lighter blue background
export const FilterRow = styled(Row)`
  padding: 3px;
  border-radius: 5px;
  margin-bottom: 6px;
  box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.2);
  min-width: ${props => (props.fluid ? 'none' : '680px')};
  background: ${props => (props.header ? '#1d4484' : props.subheader ? '#609cff' : backgroundColor)};
  color: ${props => (props.header || props.subheader ? 'white' : color)};
`;
